import React from 'react';
import starRight from '../../../assets/images/star-left.png';
import starLeft from '../../../assets/images/star-left.png';

interface StarredImageProps {
  imageSrc: string;
  alt?: string;
  starPosition?: 'left' | 'right'; // default = right
}

const StarredImage: React.FC<StarredImageProps> = ({
  imageSrc,
  alt = '',
  starPosition = 'right',
}) => {
  const starImage = starPosition === 'left' ? starLeft : starRight;

  return (
    <div className="imageWrapper">
      <div className={`imageContainer`}>
        <img src={imageSrc} alt={alt} className={`mainImage`} />
      </div>
    </div>
  );
};

export default StarredImage;
